







































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import slugify from 'slugify';
import _ from 'lodash';
import router from './../router';
import { Project } from '../../../common/project';

import * as CREATE_PROJECT_QUERY from 'src/graphql/CreateProject.graphql';
import * as PROJECTS_QUERY from 'src/graphql/Projects.graphql';

@Component
export default class extends Vue {
  name = ""
  description = ""
  valid = true;
  // owner = null;
  error = null;

  nameRules = [
    v => !!v || 'Name is required',
    v => this.checkUniquePath(v),
  ];


  get owner() {
    const auth = this.$store.state.auth;

    if (!auth) {
      return 'SCA';
    }

    // return auth.idTokenDecoded.sub;
    const groups = auth.accessTokenDecoded.groups;
    return groups[0];
  }


  checkUniquePath(name) {
    const projectList = this.$store.state.projectList;
    const path = this.projectPath(name);
    const found = projectList.some( project => project.path.toLowerCase() === path.toLowerCase() );
    console.log(`Found existing project path ${path}: ${found}`);
    return !found || 'Project path already exists';
  }

  projectPath(name, absolute = false) {
    return `${absolute ? '/' : ''}${slugify(this.owner)}/${slugify(name)}`;
  }

  async submit () {

    const form = this.$refs.form as any;
    if (!form.validate()) {
      return;
    }

    const input = {
      name: this.name,
      description: this.description,
      owner: this.owner,
      color: null
    };
    const path = this.projectPath(this.name, true);

    try {
      const res = await this.$apollo.mutate({
        mutation: CREATE_PROJECT_QUERY,
        variables: { input },
        update: (store, {data: { createProject }}) => {
          let data: any = store.readQuery({
            query: PROJECTS_QUERY
          });

          data.projects.push(createProject);

          store.writeQuery({
            query: PROJECTS_QUERY,
            data
          });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          createProject: {
            __typename: 'Project',
            id: -1,
            ...input,
            path,
            createdAt: 0,
            modifiedAt: 0
          },
        },
      });

      this.error = null;
      router.push(path);
    } catch (e) {
      this.error = e.message;
      console.log(`Create project error`, e);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CreateProject.vue